import { render, staticRenderFns } from "./SavePrices.vue?vue&type=template&id=0c2dc2a6&"
import script from "./SavePrices.vue?vue&type=script&lang=js&"
export * from "./SavePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports